/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationSummaryRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationSummaryRequest>): ScheduleRecommendationSummaryRequest {
        let obj = Object.assign(new ScheduleRecommendationSummaryRequest(), model);
        ScheduleRecommendationSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationSummaryRequest>): ScheduleRecommendationSummaryRequest {
        if (!model) return null;
        return ScheduleRecommendationSummaryRequest.newInstance(<ScheduleRecommendationSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationSummaryRequest) {
        if (!obj) return;

        models.ScheduleRecommendationSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant Ids
     */
    tenant_ids: Array<string>;

    /**
     * Service Account Ids
     */
    service_account_ids: Array<string>;

    /**
     * Service Names
     */
    service_names: Array<models.CloudServiceName>;

    /**
     * Currency
     */
    currency: models.Currency;

}
